import {useEffect} from 'react'
import {useCustomerProductLists, useShopperCustomersMutation} from '@salesforce/commerce-sdk-react'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'

export const useWishList = () => {
    const {data: customer} = useCurrentCustomer()
    const {customerId} = customer || {}
    const isGuestUser = !customer?.isRegistered
    const onClient = typeof window !== 'undefined'

    const createCustomerProductList = useShopperCustomersMutation('createCustomerProductList')

    const {data: productLists, ...restOfQuery} = useCustomerProductLists(
        {parameters: {customerId}},
        {
            onSuccess: async (data) => {
                if (!data?.total) {
                    // If no wishlist, create one
                    createCustomerProductList.mutate({
                        parameters: {customerId},
                        body: isGuestUser
                            ? {type: 'wish_list'}
                            : {type: 'wish_list', name: 'My Wishlist'}
                    })
                }
            },
            enabled: onClient && Boolean(customerId)
        }
    )

    const allLists = productLists?.data || []
    const guestUserDefaultWishlist = [allLists.find((list) => list?.type === 'wish_list')]
    const registeredUserDefaultWishlist =
        [allLists.find((list) => list?.name === 'My Wishlist')] || []
    const registeredUserWishlist = [
        ...registeredUserDefaultWishlist,
        ...allLists.filter((list) => list?.name !== 'My Wishlist')
    ]

    useEffect(() => {
        if (!onClient) return
        if (!isGuestUser) return

        const items = guestUserDefaultWishlist.flatMap(
            (list) => list?.customerProductListItems || []
        )
        if (items?.length === 0) return

        const existing = JSON.parse(localStorage.getItem('guestWishlistItems') || '[]')
        const hasDifference =
            existing?.length !== items?.length ||
            existing?.some(
                (exItem, idx) =>
                    exItem.productId !== items[idx]?.productId ||
                    exItem.quantity !== items[idx]?.quantity
            )

        if (hasDifference) {
            localStorage.setItem('guestWishlistItems', JSON.stringify(items))
        }
    }, [isGuestUser, guestUserDefaultWishlist])

    return {
        data: {
            productWishList: isGuestUser ? guestUserDefaultWishlist : registeredUserDefaultWishlist,
            registeredUserWishlists: registeredUserWishlist || []
        },
        ...restOfQuery
    }
}
